import React, { useEffect } from "react";
import Header from "../landingsections/Header";
import FloatIcons from "../landingsections/FloatIcons";
import Footer from "../landingsections/Footer";
import AOS from "aos";
import "aos/dist/aos.css";


const TermsCondition = () => {

 
useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);


  return (
    <div className="page-wrapper">

      <Header />

      <div className="container py-5">

        <div className="text-center mb-5" data-aos="fade-up">
          <h1 className="fw-bold">Terms & Conditions</h1>
          <p className="text-muted">Welcome to azsmenterprises.com</p>
        </div>

        <div className="card shadow-sm border-0 mb-4" data-aos="fade-up">
          <div className="card-body text-muted">
            <p>
              Welcome to the Terms and Conditions ("Terms") for the use of our website.
              These Terms apply to all services, features, and content provided by us.
              By accessing or using our website, you agree to be bound by these Terms.
              If you do not agree, please refrain from using our website.
            </p>
          </div>
        </div>

        <div className="card shadow-sm border-0 mb-4" data-aos="fade-right">
          <div className="card-body">
            <h4 className="fw-bold mb-3">Acceptance of Terms</h4>
            <p className="text-muted">
              By using our website, you confirm that you have read, understood,
              and agreed to these Terms. If you disagree with any part, you must not use the website.
            </p>
          </div>
        </div>

        <div className="card shadow-sm border-0 mb-4" data-aos="fade-left">
          <div className="card-body">
            <h4 className="fw-bold mb-3">Intellectual Property Rights</h4>
            <p className="text-muted">
              All content including text, graphics, logos, images, videos, and software
              is owned by us or our licensors and protected by intellectual property laws.
              You may not copy, reproduce, or distribute any content without permission.
            </p>
          </div>
        </div>

        <div className="card shadow-sm border-0 mb-4" data-aos="fade-up">
          <div className="card-body">
            <h4 className="fw-bold mb-3">Use of the Website</h4>
            <ul className="text-muted">
              <li>Use the website only for lawful purposes.</li>
              <li>Do not damage, overload, or interfere with the website.</li>
              <li>Do not attempt unauthorized access to systems or networks.</li>
              <li>No bots, crawlers, or scraping without permission.</li>
            </ul>
          </div>
        </div>

        <div className="card shadow-sm border-0 mb-4" data-aos="fade-right">
          <div className="card-body">
            <h4 className="fw-bold mb-3">Third-Party Links</h4>
            <p className="text-muted">
              We may include links to third-party websites. We are not responsible
              for their content, policies, or practices.
            </p>
          </div>
        </div>

        <div className="card shadow-sm border-0 mb-4" data-aos="fade-left">
          <div className="card-body">
            <h4 className="fw-bold mb-3">Disclaimer of Warranties</h4>
            <p className="text-muted">
              All content is provided "as is" without warranties of any kind.
              We do not guarantee accuracy, reliability, or completeness.
            </p>
          </div>
        </div>

        <div className="card shadow-sm border-0 mb-4" data-aos="zoom-in">
          <div className="card-body">
            <h4 className="fw-bold mb-3">Limitation of Liability</h4>
            <p className="text-muted">
              We are not liable for any direct or indirect damages, including
              loss of data, profits, or business interruptions.
            </p>
          </div>
        </div>

        <div className="card shadow-sm border-0 mb-4" data-aos="zoom-in">
          <div className="card-body">
            <h4 className="fw-bold mb-3">Indemnification</h4>
            <p className="text-muted">
              You agree to indemnify and hold us harmless from any claims,
              damages, or expenses arising from your use of the website.
            </p>
          </div>
        </div>

        <div className="card shadow-sm border-0 mb-4" data-aos="fade-up">
          <div className="card-body">
            <h4 className="fw-bold mb-3">Modification of Terms</h4>
            <p className="text-muted">
              We may update these Terms at any time. Continued use of the website
              means you accept the updated Terms.
            </p>
          </div>
        </div>

        <div className="card shadow-sm border-0 mb-4" data-aos="fade-up">
          <div className="card-body">
            <h4 className="fw-bold mb-3">Governing Law & Jurisdiction</h4>
            <p className="text-muted">
              These Terms shall be governed by and interpreted in accordance with
              the applicable laws of your jurisdiction.
            </p>
          </div>
        </div>

        <div className="text-center mt-5" data-aos="fade-up">
          <p className="fw-semibold">
            By continuing to use our website, you agree to these Terms & Conditions.
          </p>
        </div>

      </div>

      <FloatIcons />
      <Footer />

    </div>
  );
};

export default TermsCondition;